import AmpService from "analytics/amplitude/amplitudeEvents";
import PagePlaceholder, { PLACEHOLDER_PAGE_TYPE } from "component/category/PagePlaceholder";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import isHomePage from "util/helper/isHomePage";
import isSafariBrowser from "util/helper/isSafari";
import { useDispatch } from "react-redux";
import { openModal } from "action/modal/openModal";
import useScreenSize from "../../hoc/useScreenSize";

const HomeRegularContainer = dynamic(() => import(/* webpackChunkName: "home-desktop" */ "./HomeRegularContainer"),
  { loading: () => <PagePlaceholder pageType={PLACEHOLDER_PAGE_TYPE.HOME_PAGE} /> });
const HomeCompactContainer = dynamic(() => import(/* webpackChunkName: "home-mobile" */ "./HomeCompactContainer"),
  { loading: () => <PagePlaceholder pageType={PLACEHOLDER_PAGE_TYPE.HOME_PAGE} /> });

function HomeContent(props: any) {
  const { homeJson } = props;

  const router = useRouter();
  const { pathname, isReady } = router;
  const [isInteractionEventCaptured, setIsInteractionEventCaptured] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!router.isReady) return;

    const referralId = new URLSearchParams(
      window.location.search,
    ).get("referralId");

    if (referralId) {
      dispatch(
        openModal("referAndEarnModal", {
          uuid: referralId,
        }),
      );
    }
  }, [isReady]);

  function sendInteractionEvent() {
    if (isSafariBrowser() && isHomePage(pathname) && !isInteractionEventCaptured) {
      setIsInteractionEventCaptured(true);
      AmpService.safariHpInteraction();
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", sendInteractionEvent);
    window.addEventListener("click", sendInteractionEvent);

    return () => {
      window.removeEventListener("scroll", sendInteractionEvent);
      window.removeEventListener("click", sendInteractionEvent);
    };
  }, []);

  const {
    banners,
    sponsoredBrandsV2,
    googleReviews,
    articles,
    regularServices,
    topCategories,
    actionGridData,
    highTrafficPageData,
    categoryCards,
  } = homeJson;

  const [isMobile] = useScreenSize();

  const propsToPass = {
    banners,
    googleReviews,
    sponsoredBrandsV2,
    articles,
    regularServices,
    topCategories,
    actionGridData,
    highTrafficPageData,
    categoryCards,
  };
  const renderChild = isMobile ? <HomeCompactContainer {...propsToPass} /> : <HomeRegularContainer {...propsToPass} />;

  return renderChild;
}

export default HomeContent;
